(() => {
  if (window.__aiBadgeBound) {
    return;
  }

  window.__aiBadgeBound = true;

  const dialog = () => document.getElementById('ai-badge-dialog');

  const isAiImage = (img) => {
    const haystack = `${img.getAttribute('src') || ''} ${img.getAttribute('srcset') || ''}`.toLowerCase();
    const alt = img.getAttribute('alt') || '';
    return haystack.includes('-ai') || /\bai\b/i.test(alt);
  };

  const shouldSkipImage = (img) => {
    if (img.closest('.ai-badge, header, footer, .swatch, .country-flag')) {
      return true;
    }

    if (img.closest('.product-gallery__thumbnail')) {
      return true;
    }

    const width = img.naturalWidth || img.width || 0;
    if (width > 0 && width < 80) {
      return true;
    }

    return false;
  };

  const findHost = (img) => {
    return (
      img.closest(
        '.ai-badge-host, .product-gallery__media-inner, .product-card__figure, .product-card-image-carousel__item-media, .horizontal-product-card__figure, .content-over-media, .gtc-images__item-inner, .shop-the-look__image-wrapper, .multi-column__media, .image-with-text__media, .mega-menu__image'
      ) || img.parentElement
    );
  };

  const decorateImages = () => {
    const template = document.getElementById('ai-badge-template');
    if (!template) {
      return;
    }

    document.querySelectorAll('img').forEach((img) => {
      if (!isAiImage(img) || shouldSkipImage(img)) {
        return;
      }

      const host = findHost(img);
      if (!host || host.querySelector('.ai-badge')) {
        return;
      }

      const button = template.content.firstElementChild.cloneNode(true);
      if (img.closest('.product-card, .horizontal-product-card, .product-card-image-carousel')) {
        button.classList.add('ai-badge--compact');
        button.querySelector('.ai-badge__text')?.remove();
      }

      if (getComputedStyle(host).position === 'static') {
        host.style.position = 'relative';
      }

      host.appendChild(button);
    });
  };

  document.addEventListener(
    'click',
    (event) => {
      const badge = event.target.closest('.ai-badge');
      if (badge) {
        event.preventDefault();
        event.stopPropagation();
        dialog()?.showModal?.();
        return;
      }

      const closeButton = event.target.closest('.ai-badge__dialog-close');
      if (closeButton) {
        closeButton.closest('dialog')?.close();
        return;
      }

      const openDialog = event.target.closest('dialog.ai-badge__dialog');
      if (!openDialog) {
        return;
      }

      const rect = openDialog.getBoundingClientRect();
      const isClickInsideDialog =
        event.clientX >= rect.left &&
        event.clientX <= rect.right &&
        event.clientY >= rect.top &&
        event.clientY <= rect.bottom;

      if (!isClickInsideDialog) {
        openDialog.close();
      }
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', decorateImages);
  } else {
    decorateImages();
  }

  document.addEventListener('shopify:section:load', decorateImages);
})();
